import { module as BaseModule } from 'modujs';

export default class extends BaseModule {
  constructor(m) {
    super(m);

    this.events = {
      change: {
        'agree-checkbox': 'toggleSubmitButton'
      },
      submit: 'submitContact'
    };
  }

  init() {
    this.initEvents();
  }

  initEvents() {
    this.$('form')[0].addEventListener('change', ev => {
      grecaptcha?.ready(() => {
        grecaptcha.execute(
          '6LcxXpMfAAAAAJrdGmd8q52znxkziFRkLqqNSpph',
          {
            action: 'contact'
          }
        ).then(token => {
          this.$('recaptcha')[0].setAttribute('value', token);
        });
      });
    }, { once: true });
  }

  toggleSubmitButton(ev) {
    if (ev.target.checked) {
      this.$('submit')[0].removeAttribute('disabled');
    } else {
      this.$('submit')[0].setAttribute('disabled', '');
    }
  }

  submitContact( event ) {
    event.preventDefault();

    const responseElement = this.$('response')[0];
    const submitButton = this.$('submit')[0];
    const submitButtonOriginalContent = submitButton.innerHTML;
    const formData = new FormData( event.target );

    formData.append( 'sec', RSQ_XHR.sec );
    formData.append( 'action', 'do_contact' );

    submitButton.setAttribute('disabled', true);
    submitButton.children[1].innerText = 'Enviando…';
    responseElement.innerHTML = '';

    fetch(RSQ_XHR.url, {
      method: 'POST',
      credentials: 'same-origin',
      body: formData
    })
      .then(res => res.ok ? res.json() : Promise.reject(res))
      .then(response => {
        //console.log( response );
        if (response.success) {
          window.setTimeout(() => {
            submitButton.outerHTML = `<p>${ response.data.message }</p>`;
          }, 1000);
        } else {
          //const errorField = formElement.querySelector(SELECTOR.ERROR + response.data.selector);
          //errorField.innerHTML = response.data.message;
          responseElement.innerHTML = response.data.message;
          submitButton.innerHTML = submitButtonOriginalContent;
          submitButton.disabled = false;
        }
      })
      .catch(err => {
        console.error(err.message);
        //submitButton.innerHTML = submitButtonOriginalContent;
        //submitButton.disabled = false;
      })
    ;
  }
}
